import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-relatorio-pagamento-decendial',
  templateUrl: './relatorio-pagamento-decendial.component.html',
  styleUrls: ['./relatorio-pagamento-decendial.component.scss']
})
export class RelatorioPagamentoDecendialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
